import React from 'react';

const RHIFailedIllustration = ({ ...props }: React.ComponentProps<'svg'>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="143"
      height="71"
      viewBox="0 0 143 71"
      fill="none"
      {...props}
    >
      <path
        d="M131.697 34.1024C132.558 34.1024 133.257 33.404 133.257 32.5424C133.257 31.6809 132.558 30.9824 131.697 30.9824C130.835 30.9824 130.137 31.6809 130.137 32.5424C130.137 33.404 130.835 34.1024 131.697 34.1024Z"
        fill="#FBC4A9"
      />
      <path
        d="M50.5756 3.86219C51.4372 3.86219 52.1356 3.16375 52.1356 2.30218C52.1356 1.44062 51.4372 0.742188 50.5756 0.742188C49.7141 0.742188 49.0156 1.44062 49.0156 2.30218C49.0156 3.16375 49.7141 3.86219 50.5756 3.86219Z"
        fill="#FBC4A9"
      />
      <path
        d="M128.936 5.74645L130.873 7.49072L136.522 1.76552L134.585 0.0212478L128.936 5.74645Z"
        fill="#FFC700"
      />
      <path
        d="M133.891 11.4605L135.062 13.7505L142.4 10.2167L141.229 7.9267L133.891 11.4605Z"
        fill="#FFC700"
      />
      <path
        d="M1.57455 28.1891C4.14062 32.9152 10.0521 34.6662 14.7782 32.1001C19.5043 29.534 21.2553 23.6226 18.6893 18.8965C16.1232 14.1704 10.2117 12.4193 5.48561 14.9854C0.759513 17.5515 -0.991528 23.463 1.57455 28.1891Z"
        fill="#E06358"
      />
      <path
        d="M8.92272 24.9158L10.0326 17.1241L13.5088 18.0722L10.7325 25.4199L8.92272 24.9158Z"
        fill="#FFF2E8"
      />
      <path
        d="M7.79009 28.3004C8.21777 29.0881 9.20302 29.38 9.9907 28.9523C10.7784 28.5246 11.0702 27.5393 10.6425 26.7517C10.2149 25.964 9.22962 25.6721 8.44194 26.0998C7.65425 26.5275 7.36241 27.5127 7.79009 28.3004Z"
        fill="#FFF2E8"
      />
      <path
        d="M18.1933 25.5162L23.2902 32.7523L15.3017 29.6492"
        fill="#E06358"
      />
      <path
        d="M37.1348 10.7012V64.4612"
        stroke="#571541"
        stroke-width="7.68"
        stroke-linecap="round"
      />
      <path
        d="M114.775 9.86133V63.6213"
        stroke="#571541"
        stroke-width="7.68"
        stroke-linecap="round"
      />
      <path
        d="M28.8555 17.7828C28.8555 16.4573 29.93 15.3828 31.2555 15.3828H122.215C123.541 15.3828 124.615 16.4573 124.615 17.7828V26.1828C124.615 27.5083 123.541 28.5828 122.215 28.5828H31.2555C29.93 28.5828 28.8555 27.5083 28.8555 26.1828V17.7828Z"
        fill="#8F6380"
      />
      <path
        d="M28.8555 37.9428C28.8555 36.6173 29.93 35.5428 31.2555 35.5428H122.215C123.541 35.5428 124.615 36.6173 124.615 37.9428V46.3428C124.615 47.6683 123.541 48.7428 122.215 48.7428H31.2555C29.93 48.7428 28.8555 47.6683 28.8555 46.3428V37.9428Z"
        fill="#8F6380"
      />
      <mask
        id="mask0_5889_251712"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="28"
        y="15"
        width="97"
        height="34"
      >
        <path
          d="M39.0481 28.5828L45.7285 15.3828H54.3361L47.6556 28.5828H39.0481Z"
          fill="#355D60"
        />
        <path
          d="M28.8555 48.7224L35.5255 35.5428H44.1331L37.4526 48.7428H28.8555V48.7224Z"
          fill="#355D60"
        />
        <path
          d="M59.8525 48.7428H51.245L57.9255 35.5428H66.533L59.8525 48.7428Z"
          fill="#355D60"
        />
        <path
          d="M83.2468 48.7428H74.6392L81.3197 35.5428H89.9273L83.2468 48.7428Z"
          fill="#355D60"
        />
        <path
          d="M108.347 48.7428H99.7393L106.42 35.5428H115.027L108.347 48.7428Z"
          fill="#355D60"
        />
        <path
          d="M124.615 16.5976L118.55 28.5828H109.942L116.623 15.3828H124.615V16.5976Z"
          fill="#355D60"
        />
        <path
          d="M91.5227 15.3828H100.13L93.4497 28.5828H84.8422L91.5227 15.3828Z"
          fill="#355D60"
        />
        <path
          d="M68.1284 15.3828H76.7359L70.0554 28.5828H61.4479L68.1284 15.3828Z"
          fill="#355D60"
        />
      </mask>
      <g mask="url(#mask0_5889_251712)">
        <path
          d="M28.8555 17.7828C28.8555 16.4573 29.93 15.3828 31.2555 15.3828H122.215C123.541 15.3828 124.615 16.4573 124.615 17.7828V26.1828C124.615 27.5083 123.541 28.5828 122.215 28.5828H31.2555C29.93 28.5828 28.8555 27.5083 28.8555 26.1828V17.7828Z"
          fill="#571541"
        />
        <path
          d="M28.8555 37.9428C28.8555 36.6173 29.93 35.5428 31.2555 35.5428H122.215C123.541 35.5428 124.615 36.6173 124.615 37.9428V46.3428C124.615 47.6683 123.541 48.7428 122.215 48.7428H31.2555C29.93 48.7428 28.8555 47.6683 28.8555 46.3428V37.9428Z"
          fill="#571541"
        />
      </g>
      <path
        d="M59.7666 25.685C61.183 29.5303 63.5035 33.0534 66.1329 36.2991C66.8546 37.1914 67.9734 38.4336 69.1479 39.6966L69.1255 39.6935C71.5165 42.268 74.1398 44.9272 74.154 44.9193L74.1914 44.954C74.2115 44.9731 81.5423 41.0198 84.4505 39.07C87.9185 36.7469 91.1826 34.0649 93.6644 30.8092C98.2702 24.7615 95.9748 14.362 87.5614 12.3575C84.3754 11.586 80.0419 12.7644 78.6433 15.4646C78.0844 12.4718 73.4108 9.97478 70.141 9.7575C61.5093 9.17832 57.1463 18.5477 59.7666 25.685Z"
        fill="#E06358"
      />
      <path
        d="M83.6262 33.0475L74.125 19.6016L71.4358 21.5018L80.937 34.9477L83.6262 33.0475Z"
        fill="#FFF2E9"
      />
      <path
        d="M85.2054 23.8711L83.3052 21.1819L69.8593 30.6831L71.7595 33.3723L85.2054 23.8711Z"
        fill="#FFF2E9"
      />
      <path
        d="M62.044 25.5689C61.3465 21.1193 62.0502 17.7102 64.139 15.4338C64.9362 14.5908 65.9055 13.9128 66.9888 13.4405C68.072 12.9682 69.2468 12.7114 70.4424 12.6856L70.4378 14.9407C70.4111 14.937 67.7124 14.9441 65.901 16.9407C64.2928 18.7024 63.7903 21.4992 64.3774 25.2508L62.044 25.5689Z"
        fill="#E9817B"
      />
      <path
        d="M64.8987 27.4538L62.9829 28.6558L64.5533 31.1871L66.4692 29.9851L64.8987 27.4538Z"
        fill="#E9817B"
      />
      <path
        d="M81.9627 18.654L80.3088 17.1366C81.6028 15.7455 83.3435 14.8427 85.2353 14.5817C87.127 14.3208 89.0531 14.7178 90.6861 15.7052L89.5184 17.6106C88.33 16.8903 86.9276 16.6002 85.55 16.7899C84.1723 16.9796 82.9047 17.6372 81.9631 18.6508L81.9627 18.654Z"
        fill="#E9817B"
      />
      <path
        d="M31.7363 66.9219H42.537"
        stroke="#571541"
        stroke-width="4.8"
        stroke-linecap="round"
      />
      <path
        d="M109.256 66.9824H120.057"
        stroke="#571541"
        stroke-width="4.8"
        stroke-linecap="round"
      />
    </svg>
  );
};

export default RHIFailedIllustration;